import transparentLogo from '../assets/GreatChildLogo-transparent.webp';
import InnerPlaygroundView from '../assets/InnerPlaygroundView.webp';
import MainPlaygroundView from '../assets/MainPlaygroundView.webp';
import ZoomedPlaygroundWallView from '../assets/ZoomedPlaygroundWallView.webp';

export interface MediaItem {
  readonly id: string;
  readonly src: string;
  readonly alt: string;
}

export const generalMedia: Record<string, MediaItem> = {
  'greatchild-playground-photo': {
    id: 'greatchild-playground-photo',
    src:MainPlaygroundView,
    alt: 'Great Child Nursery & Pre-School playground',
  },
  'hero-section': {
    id: 'hero-section',
    src: InnerPlaygroundView,
    alt: 'Inner view of the playground',
  },
  'welcome-section-about': {
    id: 'welcome-section-about',
    src: ZoomedPlaygroundWallView,
    alt: 'Zoomed in Playground Wall View',
  },
  'general-logo': {
    id: 'general-logo',
    src: transparentLogo,
    alt: 'General logo for Great Child Nursery & Pre-School',
  }, 
  'ofsted-logo': {
    id: 'ofsted-logo',
    src: 'https://reports.ofsted.gov.uk/images/logo.svg',
    alt: 'Ofsted logo',
  }, 
} as const;
